import { render, staticRenderFns } from "./LogsPedidos.vue?vue&type=template&id=3f199c4a&scoped=true&"
import script from "./LogsPedidos.vue?vue&type=script&lang=js&"
export * from "./LogsPedidos.vue?vue&type=script&lang=js&"
import style0 from "./LogsPedidos.vue?vue&type=style&index=0&id=3f199c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f199c4a",
  null
  
)

component.options.__file = "LogsPedidos.vue"
export default component.exports